<script lang="ts" setup>
import { computed, onMounted } from 'vue'

import { useStore } from '@/store'

import ConnectorForm from './ConnectorForm.vue'

const store = useStore()

const connectorsConfigList = computed(() => store.state.connectorConfig.connectorsConfigList)

onMounted(() => {
  store.dispatch('connectorConfig/getConnectorsConfigList')
})

function addEmptyConnector() {
  store.commit('connectorConfig/addEmptyConnector')
}
</script>


<template>
  <div>
    <div class="settings-table">
      <div class="settings-table__header-row row">
        <div class="col-6 settings-table__header-cell">
          <h2>Flux entrant</h2>
        </div>
      </div>
      <div class="settings-table__data-row row">
        <div class="col-12 settings-table__data-cell">
          <p class="alert alert-secondary">
            Ce flux n'est pas paramétrable pour le moment, les routes sont toujours ouvertes et la version du format est indiquée dans le message.
          </p>
        </div>
      </div>        
    </div>
    <div class="settings-table">
      <div class="settings-table__header-row row">
        <div class="col-6 settings-table__header-cell">
          <h2>Flux sortant</h2>
        </div>
      </div>
      <div class="settings-table__data-row row">
        <div class="col-12 settings-table__data-cell align-items-start">
          <connector-form
            v-for="(connectorConfig, connectorIndex) in connectorsConfigList"
            :key="connectorIndex"
            :index="connectorIndex"
            :connector="connectorConfig"
          />
          <div class="col-12">
            <button
              class="btn btn-primary btn-block my-4 w-100" 
              @click="addEmptyConnector()"
            >
              Ajouter un nouveau connecteur
            </button>
          </div>
        </div>
      </div>    
    </div>
  </div>
</template>